import { default as Footer } from './footer'

export default Footer
